import { FormattedMessage } from "react-intl";
import DeleteIcon from "@mui/icons-material/Delete";
import BaseButton from "./BaseButton";

const RemoveButton = ({ disabled, onClick }) => (
  <BaseButton
    disabled={disabled}
    onClick={onClick}
    tooltip={
      <FormattedMessage id="admin.workspaces.imageSelector.buttons.remove.tooltip" />
    }
  >
    <DeleteIcon sx={{ fontSize: "150%", margin: "0 2px 0px -3px" }} />
    <FormattedMessage id="admin.workspaces.imageSelector.buttons.remove.title" />
  </BaseButton>
);

export default RemoveButton;
